// Geofencing utility for SVDP Volunteer Tracking
// Parish location: 4827 N. Kenmore Ave, Chicago, IL 60640

const PARISH_LAT = 41.9713;
const PARISH_LNG = -87.6563;
const MAX_DISTANCE_FEET = 500;
const MAX_DISTANCE_METERS = MAX_DISTANCE_FEET * 0.3048; // ~152 meters

/**
 * Calculate distance between two coordinates using Haversine formula
 * Returns distance in meters
 */
function haversineDistance(lat1, lon1, lat2, lon2) {
  const R = 6371000; // Earth radius in meters
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/**
 * Check if user is within allowed distance of the parish
 * Returns a promise that resolves to { allowed: boolean, message: string, distance?: number }
 */
export function checkGeofence() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({
        allowed: false,
        message: 'Location services are not available on this device. Please use the kiosk at the parish.'
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const distance = haversineDistance(latitude, longitude, PARISH_LAT, PARISH_LNG);
        const distanceFeet = Math.round(distance / 0.3048);

        if (distance <= MAX_DISTANCE_METERS) {
          resolve({
            allowed: true,
            message: 'Location verified.',
            distance: distanceFeet
          });
        } else {
          resolve({
            allowed: false,
            message: `You need to be at the parish to check in. You appear to be about ${distanceFeet > 5280 ? Math.round(distanceFeet / 5280 * 10) / 10 + ' miles' : distanceFeet + ' feet'} away.`,
            distance: distanceFeet
          });
        }
      },
      (error) => {
        let message;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = 'Location access was denied. Please enable location services and try again, or use the kiosk at the parish.';
            break;
          case error.POSITION_UNAVAILABLE:
            message = 'Unable to determine your location. Please try again or use the kiosk at the parish.';
            break;
          case error.TIMEOUT:
            message = 'Location request timed out. Please try again.';
            break;
          default:
            message = 'Unable to verify your location. Please use the kiosk at the parish.';
        }
        resolve({ allowed: false, message });
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000 // Cache location for 1 minute
      }
    );
  });
}
